<template>
  <v-speed-dial
    v-model="fab"
    absolute
    :top="true"
    :right="true"
    direction="bottom"
    :open-on-hover="false"
    transition="slide-y-reverse-transition"
  >
    <template v-slot:activator>
      <v-btn
        v-model="fab"
        small
        :color="fab ? 'primary' : 'white'"
        fab
        dark
        elevation="3"
      >
        <v-icon v-if="fab">
          mdi-close
        </v-icon>
        <v-avatar
          v-else
          color="white"
          size="36"
        >
          <img
            class="speed-dial-img"
            src="../../assets/img/mais-logo.png"
            alt="Menu"
          >
        </v-avatar>
      </v-btn>
    </template>
    <v-btn
      v-show="isInfoButtonActive"
      fab
      small
      color="primary"
      elevation="3"
      @click="openLOInfo()"
    >
      <v-icon color="white">
        mdi-information
      </v-icon>
    </v-btn>
    <v-btn
      v-show="isHelpButtonActive"
      fab
      small
      color="primary"
      href="https://www.imersys.com/ambia"
      target="_blank"
    >
      <v-icon color="white">
        mdi-help-circle
      </v-icon>
    </v-btn>
    <v-btn
      v-show="(!isIOSDevice && isARButtonActive) || (isIOSDevice && isIOSARButtonActive)"
      fab
      small
      color="primary"
      elevation="3"
      @click="activateAR()"
    >
      <v-icon color="white">
        mdi-cube-outline
      </v-icon>
    </v-btn>
    <v-btn
      v-show="isAnimationAvailable"
      fab
      small
      color="primary"
      elevation="3"
      @click="playPauseAnimation"
    >
      <v-icon color="white">
        {{ isAnimationPaused ? 'mdi-play' : 'mdi-pause' }}
      </v-icon>
    </v-btn>
    <v-btn
      v-show="isFullscreenButtonActive"
      fab
      small
      color="primary"
      elevation="3"
      @click="requestFullscreen"
    >
      <v-icon color="white">
        {{ isInFullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}
      </v-icon>
    </v-btn>
  </v-speed-dial>
</template>
<script>

import { isIOS } from 'mobile-device-detect';
import toggleFullscreen from '../../utils/fullscreen';

export default {
  name: 'MenuButton',
  props: {
    isAnimationAvailable: {
      type: Boolean,
      default: false,
    },
    isAnimationPaused: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fab: false,
      marginTop: 'mt-2',
      isInFullscreen: false,
    };
  },
  computed: {
    isIOSDevice() {
      return isIOS;
    },
    isARButtonActive() {
      return this.$store.state.UIParametersObj.mobilearbutton;
    },
    isIOSARButtonActive() {
      return this.$store.state.UIParametersObj.iosarbutton;
    },
    isInfoButtonActive() {
      return this.$store.state.UIParametersObj.mobileinfobutton;
    },
    isHelpButtonActive() {
      return this.$store.state.UIParametersObj.mobilehelpbutton;
    },
    isFullscreenButtonActive() {
      return this.$store.state.UIParametersObj.mobilefullscreenbutton;
    },
  },
  methods: {
    openLOInfo() {
      this.$emit('open-lo-info');
    },
    activateAR() {
      this.$emit('activate-ar');
    },
    requestFullscreen() {
      this.isInFullscreen = toggleFullscreen();
    },
    playPauseAnimation() {
      if (this.isAnimationPaused) this.$emit('play');
      else this.$emit('pause');
    },
  },
};
</script>
<style>
.v-speed-dial {
  z-index: 1;
}
.v-speed-dial__list {
  padding: 5px 0;
}
.speed-dial-img {
  width: 34px !important;
  height: 34px !important;
}
</style>
